;(()=>{
    function openVideoPlayer(videoID) {
        const $iframeWrap = document.createElement('div');
        $iframeWrap.style.position = 'fixed'
        $iframeWrap.style.background = 'rgba(0,0,0,0.8)';
        $iframeWrap.style.top   = 0
        $iframeWrap.style.left  = 0
        $iframeWrap.style.width = '100%'
        $iframeWrap.style.height = '100vh'
        $iframeWrap.style.zIndex = 9999999999;
        $iframeWrap.style.display = 'flex';
        $iframeWrap.style.alignItems = 'center';
        $iframeWrap.style.justifyContent = 'center';
        document.body.appendChild($iframeWrap);
    
        let $content = document.createElement('div');
        $content.style.width  = '80%';
        $content.style.height = '80%';
        if (window.innerWidth < 600) {
            $content.style.width  = '100%';
            $content.style.height = '100vh';
        }
        $content.style.position = 'relative';
        $iframeWrap.appendChild($content);
    
        let $close = document.createElement('button');
        $close.style.position   = 'absolute'
        $close.style.background = 'none';
        $close.style.border     = 'none';
        $close.style.bottom        = '100%';
        $close.style.fontSize   = '0px';
        $close.style.right      = 0
        $close.style.padding     = '5px'
        $close.style.zIndex     = 10
        $close.setAttribute('aria-label', 'Close video player');
        $close.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="30px" height="30px"><path fill="#fff" d="M 7.71875 6.28125 L 6.28125 7.71875 L 23.5625 25 L 6.28125 42.28125 L 7.71875 43.71875 L 25 26.4375 L 42.28125 43.71875 L 43.71875 42.28125 L 26.4375 25 L 43.71875 7.71875 L 42.28125 6.28125 L 25 23.5625 Z"/></svg>`
        
        if (window.innerWidth < 600) {
            $close.style.position = 'absolute';
            $close.style.border = 'none';
            $close.style.bottom = 'calc(100% - 50px)';
            $close.style.right = '10px';
            $close.style.padding = '10px';
            $close.style.background = '#fff';
            $close.style.borderRadius = '100px';
            $close.style.color = '#000';
            $close.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="30px" height="30px"><path fill="#000" d="M 7.71875 6.28125 L 6.28125 7.71875 L 23.5625 25 L 6.28125 42.28125 L 7.71875 43.71875 L 25 26.4375 L 42.28125 43.71875 L 43.71875 42.28125 L 26.4375 25 L 43.71875 7.71875 L 42.28125 6.28125 L 25 23.5625 Z"/></svg>`
        }
        
        $close.addEventListener('click', ()=> {
    
            document.body.removeChild($iframeWrap);
    
            let savedScroll = window.pageYOffset;
            function onHashChange(e) {
                window.removeEventListener('hashchange', onHashChange);
                if (window.preventScroll) {
                    console.log('window.preventScroll');
                    e.preventDefault();
                    window.scrollTo(0,savedScroll);
                    window.preventScroll = false;
                }
            }
            window.addEventListener('hashchange', onHashChange);
            
            window.preventScroll = true
            window.location.hash = '';
    
        });
        $content.appendChild($close);
    
        let $iframe = document.createElement('iframe');
        $iframe.style.width  = '100%'
        $iframe.style.height = '100%'
        $iframe.setAttribute('frameborder',0) 
        $iframe.setAttribute('tabindex', 0)
        $iframe.setAttribute('allow', 'autoplay; fullscreen')
        $iframe.setAttribute('src', `https://www.youtube-nocookie.com/embed/${videoID}?autoplay=1&autohide=1&fs=1&modestbranding=1&showinfo=0&controls=2&autoplay=1&rel=0&theme=light&vq=hd720`);
        $content.appendChild($iframe);
    
        
        window.location.hash = '#video-' + videoID;
    
        requestAnimationFrame(()=>{
            $iframe.focus();
        })
    }
    
        
    if (document.readyState === 'complete') {
        onReady()
    }
    else {
        window.addEventListener("DOMContentLoaded", onReady );
    }
    
    function onReady() {
        console.log('YoutubePlayer.js');
        const $players = document.querySelectorAll('[yt-player-btn]');
        $players.forEach(($btn)=>{
            function initIframe(e) {
                if (window.preventClick) {
                    return;
                }
                let videoID = e.currentTarget.getAttribute('yt-video-id');
                if (window.innerWidth < 600 && e.currentTarget.hasAttribute('yt-video-id-mobile')) {
                    videoID = e.currentTarget.getAttribute('yt-video-id-mobile');
                }
                openVideoPlayer(videoID);
            }
            $btn.addEventListener('click', initIframe)
        })
        if (/\#video\-/.test(window.location.hash)) {
            openVideoPlayer(window.location.hash.replace('#video-', ''));
        }
    }
})();